import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { ReactComponent as NebulyxLogo } from '../assets/images/Nebulyx-full-logo.svg';

const Header = () => (
    <Navbar expand="lg" className="navbar-dark bg-primary sticky-top">
        <Container>
            <Navbar.Brand as={Link} to="/">
                <span className="d-inline-block align-top" style={{ height: "40px" }}>
                    <NebulyxLogo className="me-0 pe-0 be-0" height={"2.1rem"} width={"8.5rem"} alt="Nebulyx AI Platform" fill="white" />
                </span>
                <b>– AI Platform</b>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <Nav.Link as={NavLink} to="/">Home</Nav.Link>
                    <Nav.Link as={HashLink} to="/products">Products</Nav.Link>
                    <Nav.Link as={NavLink} to="/use-cases">Use Cases</Nav.Link>
                    <Nav.Link as={NavLink} to="/blog">Blog</Nav.Link>
                    <Nav.Link as={HashLink} to="/#contact">Contact Us</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>
);

export default Header;